import { gsap } from 'gsap';
import '../util/easings';
import { mq } from '../util/matchMedia';
import { readGlobalState } from '../util/helpers';
import { studioCarousel } from '../components/studioCarousel';

export const animateIn = (() => {
  const tl = gsap.timeline({ paused: true });
  const FADE_DURATION = 1;
  const TOTAL_DURATION = 2.66;
  let studio, images, heading, text, nav, logo;

  const init = () => {
    getReferenceElements();
    setUpTimeline();
    play();
    studioCarousel.play();
  }

  const play = () => tl.play(0);

  const getReferenceElements = () => {
    studio = document.querySelector(`.js-studio-gallery-${readGlobalState('mq')}`);
    images = studio.querySelectorAll('.js-studio-image');
    heading = document.querySelector('.js-studio-heading');
    text = gsap.utils.toArray('.js-studio-text p');
    nav = document.querySelector('.js-navigation');
    logo = document.querySelector('.js-navigation-logo');
  }

  const setUpTimeline = () => {
    const textDelay = mq.isDesktop ? 1 : 0;

    tl
      .fromTo(images,
        { autoAlpha: 0 },
        {
          autoAlpha: 1,
          duration: FADE_DURATION,
          ease: 'Power1.inOut',
          stagger: {
            axis: null,
            from: 'random',
            amount: TOTAL_DURATION,
          },
        }, 0)

      .fromTo(heading,
        { autoAlpha: 0 },
        {
          autoAlpha: 1,
          duration: 0.783,
          ease: 'kota.easeIn.1',
        }, textDelay)

      .fromTo(heading,
        { y: 40 },
        {
          y: 0,
          duration: 0.783,
          ease: 'kota.easeOut.4',
        }, textDelay)

      .fromTo(text,
        { autoAlpha: 0 },
        {
          autoAlpha: 1,
          stagger: 0.18,
          duration: 0.783,
          ease: 'kota.easeIn.1',
        }, textDelay)

      .fromTo(text,
        { y: 40 },
        {
          y: 0,
          duration: 0.783,
          stagger: 0.18,
          ease: 'kota.easeOut.4',
        }, textDelay)

      .set(nav, {
        autoAlpha: 1,
      }, 0)

    if (mq.isDesktop) {
      tl.set(logo, {
        autoAlpha: 1,
      }, 0)
    }
  }

  return { init, play };
})();
